import {
  SET_APP_CONTAINER_WIDTH,
  SET_APP_ERROR,
  SET_APP_TIMEZONE
} from '../constants/actionTypes';

const initialState = {
  loading: false,
  timezone: null,
  errors: [],
  appWidth: 960
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_CONTAINER_WIDTH:
      return { ...state, appWidth: action.payload };
    case SET_APP_TIMEZONE:
      return { ...state, timezone: action.payload };
    case SET_APP_ERROR:
      return {
        ...state,
        errors: [...state.errors, action.payload]
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/app.js